import { render, staticRenderFns } from "./RsaConfigurazionePaiDomiciliareAccessiCategorieListComponent.vue?vue&type=template&id=2f152249"
import script from "./RsaConfigurazionePaiDomiciliareAccessiCategorieListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazionePaiDomiciliareAccessiCategorieListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports